import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { images, site } from '../data/site';
interface SeoProps {
  title: string;
  description: string;
}
function upsertMeta(selector: string, attrs: Record<string, string>) {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([key, value]) => el!.setAttribute(key, value));
}
export function Seo({
  title,
  description
}: SeoProps) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = 'nl';
    const canonicalUrl = `${window.location.origin}${pathname}`;
    upsertMeta('meta[name="description"]', {
      name: 'description',
      content: description
    });
    upsertMeta('meta[name="robots"]', {
      name: 'robots',
      content: 'index, follow, max-image-preview:large'
    });
    upsertMeta('meta[property="og:title"]', {
      property: 'og:title',
      content: title
    });
    upsertMeta('meta[property="og:description"]', {
      property: 'og:description',
      content: description
    });
    upsertMeta('meta[property="og:type"]', {
      property: 'og:type',
      content: 'website'
    });
    upsertMeta('meta[property="og:locale"]', {
      property: 'og:locale',
      content: 'nl_NL'
    });
    upsertMeta('meta[property="og:site_name"]', {
      property: 'og:site_name',
      content: site.name
    });
    upsertMeta('meta[property="og:url"]', {
      property: 'og:url',
      content: canonicalUrl
    });
    upsertMeta('meta[property="og:image"]', {
      property: 'og:image',
      content: images.cover
    });
    upsertMeta('meta[name="twitter:card"]', {
      name: 'twitter:card',
      content: 'summary_large_image'
    });
    upsertMeta('meta[name="twitter:title"]', {
      name: 'twitter:title',
      content: title
    });
    upsertMeta('meta[name="twitter:description"]', {
      name: 'twitter:description',
      content: description
    });
    upsertMeta('meta[name="twitter:image"]', {
      name: 'twitter:image',
      content: images.cover
    });
    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);
  }, [title, description, pathname]);
  return null;
}